import { services } from "../utils/Data";

export default function ServicesPage() {
  return (
    <div className="services-page">

      {/* ================= HEADER ================= */}
      <div className="services-header">
        <h1>Our Services</h1>
        <div className="services-header-line"></div>
      </div>

      {/* ================= SERVICES GRID ================= */}
      <div className="services-grid">
        {services
          .filter((e) => e.subCategory === undefined)
          .map((item) => (
            <a
              key={item.id}
              href={`/services/${item.id}`}
              className="service-card"
            >

              {/* IMAGE */}
              <div className="service-image-box">
                <img
                  src={item.imageSrc}
                  alt={item.course}
                  className="service-image"
                />

                <div className="image-shine"></div>
              </div>

              {/* CONTENT */}
              <div className="service-content">

                <h2>{item.course}</h2>

                <p>{item.profession}</p>

                {/* READ MORE */}
                <div className="service-bottom">
                  <span className="read-more">
                    Read More
                    <span className="read-arrow">→</span>
                  </span>
                </div>

              </div>
            </a>
          ))}
      </div>

      {/* ================= STYLES ================= */}
      <style>{`

        /* =====================================================
           MAIN PAGE
        ===================================================== */

        .services-page {
          width: 100%;
          padding: 35px 45px 60px;
          background:
            radial-gradient(
              circle at 10% 10%,
              rgba(53, 169, 62, 0.04),
              transparent 35%
            ),
            #ffffff;
        }


        /* =====================================================
           HEADER
        ===================================================== */

        .services-header {
          margin-bottom: 28px;
          text-align: left;
        }

        .services-header h1 {
          margin: 0;

          font-size: 24px;
          line-height: 1.2;

          font-weight: 500;

          letter-spacing: -0.3px;

          color: #193b21;
        }

        .services-header-line {
          width: 42px;
          height: 2px;

          margin-top: 8px;

          border-radius: 10px;

          background: #35a93e;
        }


        /* =====================================================
           GRID
        ===================================================== */

        .services-grid {
          display: grid;

          grid-template-columns:
            repeat(4, minmax(0, 1fr));

          gap: 24px;
        }


        /* =====================================================
           CARD
        ===================================================== */

        .service-card {
          position: relative;

          display: flex;
          flex-direction: column;

          min-width: 0;

          text-decoration: none;

          overflow: hidden;

          border-radius: 18px;

          background: #ffffff;

          border: 1px solid #e6eee7;

          box-shadow:
            0 8px 20px rgba(22, 53, 29, 0.07),
            0 2px 5px rgba(0, 0, 0, 0.03);

          transform: translateY(0);

          transition:
            transform 0.35s ease,
            box-shadow 0.35s ease,
            border-color 0.35s ease;

          perspective: 1000px;
        }


        /* 3D HOVER */

        .service-card:hover {
          transform:
            translateY(-8px)
            rotateX(1deg)
            rotateY(-1deg);

          border-color: rgba(53, 169, 62, 0.35);

          box-shadow:
            0 22px 45px rgba(22, 53, 29, 0.14),
            0 8px 15px rgba(53, 169, 62, 0.08);
        }


        /* =====================================================
           IMAGE AREA
        ===================================================== */

        .service-image-box {
          position: relative;

          height: 190px;

          display: flex;
          align-items: center;
          justify-content: center;

          overflow: hidden;

          background:
            linear-gradient(
              145deg,
              #ffffff 0%,
              #f7fcf8 55%,
              #eef8f0 100%
            );

          border-bottom: 1px solid #edf3ee;
        }


        /* IMAGE */

        .service-image {
          width: 100%;
          height: 100%;

          object-fit: contain;

          padding: 12px;

          transition:
            transform 0.45s cubic-bezier(
              0.2,
              0.8,
              0.2,
              1
            ),
            filter 0.45s ease;
        }


        /* IMAGE ZOOM */

        .service-card:hover .service-image {
          transform: scale(1.07);

          filter:
            drop-shadow(
              0 12px 14px
              rgba(22, 53, 29, 0.12)
            );
        }


        /* =====================================================
           IMAGE SHINE
        ===================================================== */

        .image-shine {
          position: absolute;

          top: 0;
          left: -120%;

          width: 70%;
          height: 100%;

          pointer-events: none;

          transform: skewX(-20deg);

          background:
            linear-gradient(
              90deg,
              transparent,
              rgba(255,255,255,0.45),
              transparent
            );

          transition: left 0.65s ease;
        }

        .service-card:hover .image-shine {
          left: 140%;
        }


        /* =====================================================
           CONTENT
        ===================================================== */

        .service-content {
          display: flex;
          flex-direction: column;

          flex: 1;

          padding: 17px 18px 18px;
        }


        /* TITLE */

        .service-content h2 {
          margin: 0;

          color: #1d3022;

          font-size: 16px;

          font-weight: 600;

          line-height: 1.45;

          transition: color 0.25s ease;
        }

        .service-card:hover .service-content h2 {
          color: #35a93e;
        }


        /* DESCRIPTION */

        .service-content p {
          margin: 8px 0 0;

          color: #6b746d;

          font-size: 12.5px;

          line-height: 1.65;

          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;

          overflow: hidden;

          min-height: 61px;
        }


        /* =====================================================
           BOTTOM
        ===================================================== */

        .service-bottom {
          margin-top: auto;

          padding-top: 15px;
        }


        /* =====================================================
           READ MORE
        ===================================================== */

        .read-more {
          display: inline-flex;

          align-items: center;

          justify-content: center;

          gap: 9px;

          padding: 8px 13px;

          border-radius: 8px;

          background: #35a93e;

          color: #ffffff;

          font-size: 12px;

          font-weight: 500;

          line-height: 1;

          box-shadow:
            0 5px 12px
            rgba(53, 169, 62, 0.18);

          transition:
            background 0.25s ease,
            box-shadow 0.25s ease,
            transform 0.25s ease;
        }


        /* ARROW RIGHT SIDE */

        .read-arrow {
          display: inline-flex;

          align-items: center;
          justify-content: center;

          font-size: 16px;

          line-height: 1;

          transition:
            transform 0.25s ease;
        }


        /* BUTTON HOVER */

        .service-card:hover .read-more {
          background: #2d9636;

          transform: translateY(-1px);

          box-shadow:
            0 7px 16px
            rgba(53, 169, 62, 0.25);
        }

        .service-card:hover .read-arrow {
          transform: translateX(4px);
        }


        /* =====================================================
           TABLET
        ===================================================== */

        @media (max-width: 1100px) {

          .services-page {
            padding-left: 28px;
            padding-right: 28px;
          }

          .services-grid {
            grid-template-columns:
              repeat(3, minmax(0, 1fr));

            gap: 20px;
          }

        }


        /* =====================================================
           SMALL TABLET
        ===================================================== */

        @media (max-width: 800px) {

          .services-page {
            padding:
              28px 20px 45px;
          }

          .services-grid {
            grid-template-columns:
              repeat(2, minmax(0, 1fr));

            gap: 18px;
          }

          .service-image-box {
            height: 175px;
          }

        }


        /* =====================================================
           MOBILE
        ===================================================== */

        @media (max-width: 550px) {

          .services-page {
            padding:
              24px 15px 40px;
          }

          .services-header {
            margin-bottom: 22px;
          }

          .services-header h1 {
            font-size: 21px;
          }

          .services-grid {
            grid-template-columns: 1fr;

            gap: 17px;
          }

          .service-image-box {
            height: 200px;
          }

          .service-content {
            padding: 16px;
          }

        }


        /* =====================================================
           VERY SMALL MOBILE
        ===================================================== */

        @media (max-width: 360px) {

          .services-page {
            padding-left: 12px;
            padding-right: 12px;
          }

          .service-image-box {
            height: 180px;
          }

        }

      `}</style>
    </div>
  );
}

